import { useEffect, useState } from 'react';
import { useCredits } from './use-credits';
import { freeUsageEndsInMs, isFreeUsageActive } from './free-usage';
import { useBlackFridaySimWindow } from './black-friday-sim';

/**
 * The open free-usage window's end (ISO), or null when there is none. Re-renders at the moment the
 * window closes, so a page left open does not keep hiding the paywall after the free hours run out.
 *
 * The Black Friday dev simulator substitutes the window HERE, at the one read every free-usage surface
 * shares, so Dev Tools ▸ Black Friday moves the band, the drawer's plan card, the Settings plan card
 * and the "Free until …" line together. Same choice `credits-widget-sim` made for the same reason; it
 * is inert without a dev-tools grant.
 */
export function useFreeUsageUntil(): string | null {
  const real = useCredits().account?.freeUsageUntilIso ?? null;
  const sim = useBlackFridaySimWindow();
  const iso = sim.sim ? sim.freeUsageUntilIso : real;
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const delay = freeUsageEndsInMs(iso, Date.now());
    if (delay === null) return undefined;
    const timer = setTimeout(() => setTick((n) => n + 1), delay + 1);
    return () => clearTimeout(timer);
  }, [iso, tick]);
  return isFreeUsageActive(iso, Date.now()) ? iso : null;
}
